export const SNACK_BAR_TIMEOUT = 4000;
